<template>
  <section class="person">
    <video loop muted playsinline preload="none" class="person__video" ref="personVideo">
      <source
        src="@/assets/img/success-ladder/blackAndWhite.mp4"
        type="video/mp4"
      />
    </video>
    <div class="person__background" :style="currentBackground"></div>
    <div class="person__wrapper">
      <SuccessHeader />
      <div class="person__panel">
        <router-link
          :to="
            helpers.buildRoute({
              name: 'SuccessDateGroup',
              params: {
                id: categoryID,
                date: $route.params.date,
                selectedYear: selectedYear,
                selectedMonth: selectedMonth,
                searchName: searchName,
              },
            })
          "
          class="panel__button-back"
        >
          <span class="panel__button-back_arrow">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 9H0.999999M0.999999 9L8.97959 17M0.999999 9L8.97959 1"
                stroke="currentColor"
              />
            </svg>
          </span>
          Назад
          <!-- {{$t('buttons.button_back')}} -->
        </router-link>
        <div class="person__profile">
          <img
            :src="activePerson.image"
            :alt="activePerson.name"
            class="profile__photo"
          />
          <div class="profile__info">
            <div class="info__name" v-html="activePerson.name"></div>
            <div class="info__nomination">
              <img
                :src="activeCategory.image"
                :alt="activeCategory.name"
                class="info__nomination_logo"
              />
              <div
                class="info__nomination_name"
                v-html="activePerson.nomination"
              ></div>
            </div>
            <div class="info__text" v-html="storyText"></div>
            <div
              class="info__read-more button button_empty"
              v-if="showButton && activeStory && activeStory.text"
              @click="readMore()"
            >
              Подробнее
            </div>
          </div>
        </div>
        <div
          v-if="activeStory.photos && activeStory.photos.length > 0"
          class="stories__photos"
        >
          <div class="stories__photos_title">Фото</div>
          <div
            v-if="activeStory.photos && activeStory.photos.length > 0"
            class="stories__photos_carousel"
          >
            <img
              src="@/assets/img/success-ladder/arrow-left.png"
              alt="arrow left"
              class="stories__photos_arrow-left"
              @click="prevPhotoSlide"
            />
            <img
              src="@/assets/img/success-ladder/arrow-right.png"
              alt="arrow right"
              class="stories__photos_arrow-right"
              @click="nextPhotoSlide"
            />

            <VueSlickCarousel ref="carouselPhoto" v-bind="settingsPhoto">
              <div
                v-for="(photo, index) in activeStory.photos"
                :key="photo.id"
                aria-hidden="true"
                tabindex="0"
                class="stories__photos_block"
                @click="dataLayerPush(index, activePerson.name)"
              >
                <img
                  :src="photo.file"
                  alt="Succes photo"
                  class="stories__photos_img"
                />
              </div>
            </VueSlickCarousel>

            <CoolLightBox
              v-if="activePhotos && activePhotos.length > 0"
              class="colllightbox"
              :items="activePhotos"
              @on-open="onOpenCoolBox($event, 'photo')"
              :index="photoIndex.index"
              @on-change="onOpenCoolBox($event, 'photo')"
              @close="photoIndex.index = null"
            >
              <div>111</div>
            </CoolLightBox>
          </div>
        </div>
        <div
          v-if="activeStory.videos && activeStory.videos.length > 0"
          class="stories__videos"
        >
          <div class="stories__photos_title">Видео</div>
          <div
            v-if="activeStory.videos && activeStory.videos.length > 0"
            class="stories__videos_carousel"
          >
            <img
              v-if="$root.isMobile"
              src="@/assets/img/success-ladder/arrow-left.png"
              alt="arrow left"
              class="stories__photos_arrow-left"
              @click="prevVideoSlide"
            />
            <img
              v-if="$root.isMobile"
              src="@/assets/img/success-ladder/arrow-right.png"
              alt="arrow right"
              class="stories__photos_arrow-right"
              @click="nextVideoSlide"
            />

            <VueSlickCarousel
              ref="carouselVideo"
              v-bind="settingsVideo"
              class="stories__videos_carousel_grid"
            >
              <div
                v-for="(video, index) in activeStory.videos"
                :key="index"
                class="video__container"
                @click="videoIndex.index = index"
              >
                <img
                  :src="video.teaser ? video.teaser : ''"
                  alt="video"
                  class="video__img"
                />
                <div
                  v-if="video.link !== '' || video.file !== ''"
                  class="video__button"
                >
                  <img
                    :src="require('@/assets/img/success-ladder/video.png')"
                    alt=""
                  />
                </div>
              </div>
            </VueSlickCarousel>

            <CoolLightBox
              v-if="activeVideos && activeVideos.length > 0"
              class="colllightbox"
              :items="activeVideos"
              @on-open="onOpenCoolBox($event, 'video')"
              :index="videoIndex.index"
              @on-change="onOpenCoolBox($event, 'video')"
              @close="videoIndex.index = null"
            >
            </CoolLightBox>
          </div>
        </div>
      </div>
      <SuccessFooter />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Trans } from '@/plugins/translation'
import SuccessFooter from '@/components/success-ladder/SuccesFooter.vue'
import SuccessHeader from '@/components/success-ladder/SuccessHeader.vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  name: 'SuccessCategory',
  components: { SuccessHeader, SuccessFooter, VueSlickCarousel, CoolLightBox },
  data() {
    return {
      video: '',
      videoIndex: { index: null },
      photoIndex: { index: null },
      showButton: true,
      storyText: '',
      settingsPhoto: {
        responsive: [
          {
            breakpoint: 10000,
            settings: {
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              arrows: false,
              dotsClass: 'slick-dots',
              adaptiveHeight: true,
              swipeToSlide: false,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              centerMode: true,
              // centerPadding: "0px",
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              // dots: false,
              // arrows: false,
              // dotsClass: 'slick-dots',
              // adaptiveHeight: true,
              // swipeToSlide: true,
            },
          },
          {
            breakpoint: 890,
            settings: {
              centerMode: true,
              // centerPadding: "0px",
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              // dots: false,
              // arrows: false,
              // dotsClass: 'slick-dots',
              // adaptiveHeight: true,
              // swipeToSlide: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              // centerPadding: "0px",
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              // dots: false,
              // arrows: false,
              // dotsClass: 'slick-dots',
              // adaptiveHeight: true,
              // swipeToSlide: true,
            },
          },
          {
            breakpoint: 620,
            settings: {
              centerMode: true,
              // centerPadding: "0px",
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              // dots: false,
              // arrows: false,
              // dotsClass: 'slick-dots',
              // adaptiveHeight: true,
              // swipeToSlide: true,
            },
          },
          {
            breakpoint: 560,
            settings: {
              centerMode: true,
              // centerPadding: "0px",
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              // dots: false,
              // arrows: false,
              // dotsClass: 'slick-dots',
              // adaptiveHeight: true,
              // swipeToSlide: true,
            },
          },
        ],
      },
      settingsVideo: {
        responsive: [
          {
            breakpoint: 10000,
            settings: 'unslick',
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
              arrows: false,
              dotsClass: 'slick-dots',
              adaptiveHeight: true,
              swipeToSlide: true,
            },
          },
        ],
      },
    }
  },
  async mounted() {
    await this.getPerson({ id: this.personID })
    await this.getStory({ id: this.personID })
    await this.StorySetView(this.personID)
    if (!Object.keys(this.category).length) {
      await this.getCategory({ id: this.categoryID })
    }
    this.storyText = this.activeStory.text.substring(0, 300)
    if (this.storyText.length) {
      this.storyText += '...'
    }

    // === Автовоспроизведение фонового видео ===
    const personVideo = this.$refs.personVideo
    if (personVideo) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= 0.75) { // минимум 75% видно
            personVideo.play().catch(() => {})
          } else {
            personVideo.pause()
          }
        })
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] })
      observer.observe(personVideo)
    }

  },
  computed: {
    ...mapGetters(['category', 'person', 'story']),
    currentLocale() {
      return Trans.currentLocale.trim()
    },
    activeCategory() {
      return this.category
    },
    personID() {
      return this.$route.params.id
    },
    categoryID() {
      return this.$route.params.categoryID
    },
    currentBackground() {
      let background = `background-color: ${this.activeCategory.color};`
      return background
    },
    activePerson() {
      return this.person
    },
    activeStory() {
      return this.story
    },
    activeVideos() {
      let arr = new Array()
      if (this.story) {
        this.story.videos.forEach((el) => {
          let obj = new Object()
          Object.keys(el).forEach((key) => {
            this.$set(obj, key, el[key])
          })
          this.$set(
            obj,
            'src',
            el.link !== '' && el.link !== null ? el.link : el.file
          )
          this.$set(obj, 'autoplay', false)
          this.$set(obj, 'muted', false)
          this.$set(obj, 'disablepictureinpicture', true)
          arr.push(obj)
        })
      }
      return arr
    },
    activePhotos() {
      let arr = new Array()
      if (this.story) {
        this.story.photos.forEach((el) => {
          let obj = new Object()
          Object.keys(el).forEach((key) => {
            this.$set(obj, key, el[key])
          })
          this.$set(obj, 'src', el.file)
          this.$set(obj, 'autoplay', true)
          arr.push(obj)
        })
      }
      return arr
    },
    selectedYear() {
      if (!this.$route.params.selectedYear) {
        return { text: 'Год', value: '' }
      }
      return this.$route.params.selectedYear
    },
    selectedMonth() {
      if (!this.$route.params.selectedMonth) {
        return { text: 'Месяц', value: '' }
      }
      return this.$route.params.selectedMonth
    },
    searchName() {
      if (!this.$route.params.searchName) {
        return ''
      }
      return this.$route.params.searchName
    },
  },
  methods: {
    ...mapActions(['getPerson', 'getCategory', 'getStory', 'StorySetView']),
    readMore() {
      this.storyText = this.activeStory.text
      this.showButton = false
    },
    dataLayerPush(index, name) {
      this.photoIndex.index = index
      if (this.$gtm) {
        this.$gtm.push({
          event: 'wall_user_foto',
          param_value: this.helpers.stripHtml(name),
        })
      }
    },
    async onOpenCoolBox(e, type) {
      let imageElement
      let imageSrc
      let image
      let videoElement = document.querySelectorAll('.cool-lightbox-video')[e]
      if (videoElement) {
        videoElement.play()
        videoElement.disablePictureInPicture = true
      }
      if (!type) return

      if (type === 'photo') {
        imageElement = document.querySelectorAll('.cool-lightbox__slide__img')[
          e
        ]
        imageSrc = imageElement.querySelector('img').dataset.src
      } else if (type === 'video') {
        imageElement = document.querySelectorAll('.cool-lightbox__slide__img')[
          e
        ]
        imageSrc = imageElement.querySelector('img').getAttribute('data-url')
      }

      try {
        image = await fetch(imageSrc)
      } catch (error) {
        return
      }

      const imageBlog = await image.blob()
      const imageURL = URL.createObjectURL(imageBlog)

      if (!imageURL) return
      const vm = this
      let a = document.createElement('div')
      a.classList.add('cool-lightbox__slide__button')
      a.innerText = 'Скачать'
      imageElement.append(a)
      a.addEventListener('click', function () {
        let b = document.createElement('a')
        b.href = imageURL
        b.download = ''
        b.click()
        if (vm.$gtm) {
          vm.$gtm.push({
            event: 'wall_user_foto_download',
            param_value: vm.helpers.stripHtml(vm.activePerson.name),
          })
        }
      })
    },
    prevPhotoSlide() {
      this.$refs.carouselPhoto.prev()
    },
    nextPhotoSlide() {
      this.$refs.carouselPhoto.next()
    },
    prevVideoSlide() {
      this.$refs.carouselVideo.prev()
    },
    nextVideoSlide() {
      this.$refs.carouselVideo.next()
    },
  },
  watch: {},
}
</script>

<style scoped>
.person__background {
  position: absolute;
  width: 100%;
  height: 100%;
  mix-blend-mode: overlay;
}
.person__video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: cover;
  opacity: 0.5;
}
.panel__button-back {
  display: flex;
  width: fit-content;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  line-height: 26px;
  cursor: pointer;
  color: inherit !important;
}
.panel__button-back:hover {
  opacity: 0.75;
}
.panel__button-back_arrow {
  width: 17px;
  height: 16px;
  margin-right: 18px;
  display: flex;
  align-items: center;
}
.person {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #0e0e0e;
  font-family: 'Jost', sans-serif;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
.person__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 50px 135px 0px 135px;
  object-position: center;
  object-fit: fill;
  z-index: 1;
}
.person__panel {
  margin-top: 35px;
  margin-bottom: 35px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  box-sizing: border-box;
  padding: 45px 45px 30px 45px;
  display: flex;
  flex-direction: column;
  z-index: 6;
}
.person__profile {
  margin-top: 45px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
.profile__photo {
  margin-right: 40px;
  display: block;
  width: 226px;
  height: 226px;
  object-fit: cover;
  object-position: center;
}
.profile__info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.info__read-more {
  padding: 10px 20px;
  color: #fff;
  margin-top: 20px;
  text-align: left;
}
.info__read-more:hover {
  color: #061b36;
}
.info__text {
  margin-top: 15px;
}
.info__name {
  font-size: 36px;
  line-height: 52px;
}
.info__nomination {
  margin-top: 22px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.info__nomination_logo {
  margin-right: 21px;
  display: block;
  width: 52px;
  height: 52px;
}
.info__nomination_name {
  font-size: 18px;
  line-height: 26px;
  color: #ecd593;
}
.stories__photos {
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
}
.stories__photos_title {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 22px;
}
.stories__photos_block {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 350px;
  height: 203px;
  cursor: pointer;
}
.stories__photos_block:hover {
  opacity: 0.7;
}
.stories__photos_img {
  display: block;
  width: 100%;
  height: 100%;
  object-position: top;
  object-fit: contain;
  box-sizing: border-box;
  padding: 0px 8px;
}
.stories__photos_carousel {
  position: relative;
  width: auto;
  height: auto;
  margin: 0 -8px;
}
.stories__photos_arrow-left,
.stories__photos_arrow-right {
  z-index: 1;
  position: absolute;
  width: 16px;
  height: 27px;
  object-fit: cover;
  object-position: center;
  top: calc(50% - 13.5px);
  cursor: pointer;
}
.stories__photos_arrow-right {
  right: 24px;
}
.stories__photos_arrow-left {
  left: 24px;
}
.stories__photos_arrow-left:hover,
.stories__photos_arrow-right:hover {
  opacity: 0.75;
}
.stories__videos {
  margin-top: 45px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
}
.stories__videos_carousel {
  position: relative;
  width: 100%;
  height: auto;
}
.stories__videos_carousel_grid {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 15px;
  row-gap: 15px;
}
.video__container {
  position: relative;
  width: 100%;
  height: 203px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.video__container:hover {
  opacity: 0.7;
}
.video__img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-position: center;
  object-fit: cover;
}
.video__button {
  z-index: 1;
  width: 14px;
  height: 18px;
  cursor: pointer;
}
.video__button:hover {
  opacity: 0.75;
}

@media screen and (max-width: 1220px) {
  .person__wrapper {
    width: 100%;
    padding: 30px;
  }
  .stories__videos_carousel_grid {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 15px;
    row-gap: 15px;
  }
}
@media screen and (max-width: 743px) {
  .stories__photos_block {
    height: auto;
  }
  .stories__videos_carousel_grid {
    display: block;
  }
  .person__wrapper {
    padding: 60px 15px;
  }
  .person__panel {
    padding: 30px 15px;
  }
  .person__profile {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
  }
  .profile__photo {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 22px;
    height: auto;
  }
  .info__name {
    width: 100%;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
  }
  .profile__info {
    align-items: center;
  }
  .info__nomination {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
  }
  .info__nomination_name {
    font-size: 24px;
    line-height: 35px;
  }
  .info__nomination_logo {
    width: 70px;
    height: 70px;
    margin-right: 0px;
  }
  .video__button {
    position: absolute;
    top: calc(50% - 7px);
    left: calc(50% - 9px);
  }
}
.colllightbox {
  z-index: 10000;
}
</style>

<style>
.cool-lightbox-video {
  width: 80% !important;
  height: 80% !important;
}

.cool-lightbox__slide__button {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000000;
  width: 240px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  background-color: #ecd593;
  opacity: 0.75;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  outline: none;
  text-align: center;
  color: #000;
  transition: 0.3s;
}

.cool-lightbox__slide__button:hover {
  opacity: 1;
}
</style>
